export default __webpack_public_path__ + "static/media/milestone2.e7681574.png";